<script setup lang="ts">
// types
import type { BlockHomepageTitleProps } from '@ts-blocks/block-homepage-title/interfaces'
import type { HomepageTitleDesktopSize } from '@hooks/blocks/block-homepage-title.hook'
// hooks
import { useBlockHomepageTitle } from '@hooks/blocks/block-homepage-title.hook'
// components
import { BrandShapeIcon } from '@UI/Brand/BrandShapeIcon'
import { AppIconStrapi } from '@UI/Icons/AppIconStrapi'

defineOptions({
  name: 'BlockHomepageTitle',
})

const props = withDefaults(defineProps<{
  block: BlockHomepageTitleProps
  desktopSize?: HomepageTitleDesktopSize
}>(), {
  desktopSize: 'display-xl',
})

const {
  refItems,
  refRootClass,
} = useBlockHomepageTitle({
  block: () => props.block,
  desktopSize: () => props.desktopSize,
})
</script>

<template>
  <h1 :class="refRootClass">
    <template
      v-for="item in refItems"
      :key="item.key"
    >
      <BrandShapeIcon
        v-if="item.type === 'icon'"
        class="block-homepage-title__mark"
        :shape="item.shape"
        :color="item.color"
      >
        <AppIconStrapi
          v-if="item.icon"
          :icon="item.icon"
        />
      </BrandShapeIcon>
      <span
        v-else
        class="block-homepage-title__word"
      >
        {{ item.text }}
      </span>
    </template>
  </h1>
</template>

<style scoped lang="scss" src="@scss/components/Blocks/BlockHomepageTitle.scss" />
